import RelacioanalizisesKerdesDto from 'app/admin/relacioanaliziseskerdes/dto/RelacioanalizisesKerdesDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class RelacioanalizisesKerdesTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'relacioanalizisesKerdesTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, RelacioanalizisesKerdesDto)))
				.catch(reject);
		});
	}
}

export default new RelacioanalizisesKerdesTableService();
